import { Quill } from 'vue2-editor'
import ImageFigure from './formats/ImageFigure'
import FrenchQuotes from './formats/FrenchQuotes'
import EnglishQuotes from './formats/EnglishQuotes'
import SanitizeClipboard from './modules/SanitizeClipboard'

export default class Bootstrap {
  static init () {
    let icons = Quill.import('ui/icons')
    icons['header'][3] = '<span>H3</span>'
    icons['header'][4] = '<span>H4</span>'
    icons['french-quotes'] = '<span>«»</span>'
    icons['english-quotes'] = '<span>“”</span>'

    Quill.register({
      'formats/image': ImageFigure,
      'formats/french-quotes': FrenchQuotes,
      'formats/english-quotes': EnglishQuotes,
      'modules/clipboard': SanitizeClipboard
    }, true)

    // Quill.debug('info')
  }
}
